import { NavSection } from "./SelectionPanel";
import { ConfigTarget, actionNeedsSetup, isAuth, slugOf } from "./actionSetup";

type Translate = (key: any, options?: any) => string;

export const DETAILS_SLUG = "details";

// What a section is called: the connector's own wording wins — an explicit
// ui:title, else the action name. Never schema.title, which is the Python config
// class name. Only a nameless auth action falls back to a generic label.
export const actionLabel = (a: any, t: Translate) =>
    a?.ui_schema?.["ui:title"] || a?.name || (isAuth(a) ? t("Credentials") : slugOf(a));

// The nav every configuration screen shows: the integration's own fields first,
// then one section per configurable action, auth first.
export function buildActionNav(
    { target, actions, t, detailsLabel, detailsNeedsSetup }: {
        // Undefined before the record exists (create flows) — no "!" badges then,
        // since nothing could have been saved yet.
        target?: ConfigTarget;
        actions: any[];
        t: Translate;
        detailsLabel?: string;
        detailsNeedsSetup?: boolean;
    },
): NavSection[] {
    const ordered = [...(actions || [])].sort((a, b) => Number(isAuth(b)) - Number(isAuth(a)));
    const nav: NavSection[] = [{
        cat: t("DETAILS"),
        items: [{ slug: DETAILS_SLUG, label: detailsLabel || t("Details"), needsSetup: !!detailsNeedsSetup }],
    }];
    if (ordered.length > 0) {
        nav.push({
            cat: t("GENERAL"),
            items: ordered.map((a) => ({
                slug: slugOf(a),
                label: actionLabel(a, t),
                needsSetup: !!target && actionNeedsSetup(target, a),
            })),
        });
    }
    return nav;
}

export const actionForSlug = (actions: any[], slug?: string) =>
    (actions || []).find((a) => slugOf(a) === slug);
